export default __webpack_public_path__ + "dff5f80bec7b45392ae9bb911fde35d7.svg";